import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JournalsService {

  constructor() { }

  private _apiUrl = environment.apiUrl;
  private _httpClient = inject(HttpClient);

  getAllJournals() {
    return this._httpClient.get(`${this._apiUrl}/v1/stock/get-all-journals`);
  }

  
}
